// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const Key_Stroke2_Corner2_Rounded = createSinglePathSVG({
  path: 'M20.303 3.697a7.5 7.5 0 0 0-12.436 7.626L2.69 16.5a1.5 1.5 0 0 0-.44 1.06v2.69a1.5 1.5 0 0 0 1.5 1.5h3A.75.75 0 0 0 7.5 21v-1.5H9a.75.75 0 0 0 .75-.75v-1.5h1.5a.75.75 0 0 0 .53-.22l.897-.897A7.5 7.5 0 0 0 15 16.5h.01a7.5 7.5 0 0 0 5.293-12.803Zm.697 5.5c-.102 3.196-2.79 5.8-5.99 5.803H15a6 6 0 0 1-2.217-.423.75.75 0 0 0-.829.158L10.94 15.75H9a.75.75 0 0 0-.75.75V18h-1.5a.75.75 0 0 0-.75.75v1.5H3.75v-2.69l5.515-5.514a.75.75 0 0 0 .158-.829A6 6 0 0 1 9 8.992c0-3.2 2.607-5.887 5.803-5.99A6 6 0 0 1 21 9.198Zm-3-2.072A1.125 1.125 0 1 1 16.875 6 1.125 1.125 0 0 1 18 7.125Z',
  viewBox: '0 0 24 24',
  glyph: 'Key_Stroke2_Corner2_Rounded',
})
